@if (commands) {
  <ul>
    @for (command of commands; track command) {
      <li class="expandable" (click)="toggle($event)">
        <h4>{{command.$type}}</h4>
        <div (click)="toggle($event)" class="expandable">
          <h4>Changes {{objectToList(command.changes).length}}</h4>
          <ul>
            @for (change of objectToList(command.changes); track change) {
              <li>
                {{change.title}} : {{change.value}}
              </li>
            }
          </ul>
        </div>
        <div (click)="toggle($event)" class="expandable">
          <h4>Payload {{objectToList(command.payload).length}}</h4>
          <ul>
            @for (data of objectToList(command.payload); track data) {
              <li>
                {{data.title}} : {{data.value}}
              </li>
            }
          </ul>
        </div>
      </li>
    }
  </ul>
}
